import { render, staticRenderFns } from "./FncNoticeDetail.vue?vue&type=template&id=081f8101&"
import script from "./FncNoticeDetail.vue?vue&type=script&lang=js&"
export * from "./FncNoticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./FncNoticeDetail.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FncNoticeDetail.vue"
export default component.exports